import {keys, prop} from 'ramda';

import {DASHBOARD_TILE_SIZES} from '../consts/dashboardTileSizes';
import {DashboardTileSize} from '../types/DashboardTileSize';
import {DASHBOARD_GRID_COLUMNS} from './allocateDashboardGrid';

const SIZE_CODE_PATTERN = /^(\d+)x(\d+)$/;

// Reads a `<columns>x<rows>` code stored with an arrangement of `gridColumns` columns. Legacy
// arrangements count columns in halves of the board, so their widths are scaled up first.
export function parseDashboardTileSizeCode(
  code: string,
  gridColumns: number
): DashboardTileSize | null {
  const parsed = SIZE_CODE_PATTERN.exec(code);

  if (parsed === null) {
    return null;
  }

  const columns = (Number(parsed[1]) * DASHBOARD_GRID_COLUMNS) / gridColumns;
  const rows = Number(parsed[2]);

  return (
    keys(DASHBOARD_TILE_SIZES).find((size) => {
      const geometry = prop(size, DASHBOARD_TILE_SIZES);

      return geometry.columns === columns && geometry.rows === rows;
    }) ?? null
  );
}
